import { render, staticRenderFns } from "./FleetVesselsCard.vue?vue&type=template&id=234ec026&scoped=true&"
import script from "./FleetVesselsCard.vue?vue&type=script&lang=js&"
export * from "./FleetVesselsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "234ec026",
  null
  
)

export default component.exports